import React from 'react';
import { Button, Input, Label } from 'semantic-ui-react';

import ACCOUNTS from '../mockAccounts';
import ListViewTable from '../../../components/ListViewTable';

const Accounts = ({ nextStep }) => (
  <React.Fragment>
    <Input icon="search" placeholder="Search" />
    <ListViewTable
      columns={[
        {label: 'Org Name', key: 'org_name'},
        {label: 'Account Id', key: 'account_id'},
        {label: 'Version', key: 'version'},
      ]}
      rows={ACCOUNTS.map((a) => ({
        ...a,
        version: (
          a.upgraded
          ? <Label basic color="green">Denali 2.0</Label>
          : <Button as={Label} color="red" onClick={nextStep}>Denali 1.0</Button>
        ),
      }))}
    />
  </React.Fragment>
);

export default {
  title: 'Account',
  description: 'Choose account',
  icon: 'building',
  component: Accounts,
};
